import { apolloClientService } from "../../../../services/apollo-client";
import { config } from "../../../../enviroment";
export const payment = {
    paymentreceiptapi,
    slabRates
    
};

 function paymentreceiptapi(accountId,payId){
    let tenantCode = config.constants.BASE_TENANT_CODE;
    let APIquery=
     `{getPaymentReceipt{accountNumber,paymentEventId,paymentDate,isPrepaidPay,paymentStatus,curSymbol,cardType,cardNumber,premise,amountPaid,amountPaidInWords,matchIdType,matchIdValue,payId,payType,payMode,custom,documentBase64}}
     `  
let   headers= {
    accountId: accountId,
    payId: payId,
    tenantCode: tenantCode,
}
return apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only")
}


function slabRates(txnId){
    let tenantCode = config.constants.BASE_TENANT_CODE;
    let APIquery=`{getSlabRates(input: { billSegId:"${txnId}"}){

        slabRates __typename
    
    }}`
let   headers= {
    tenantCode: tenantCode,
}
return apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only")
}
